import styled from 'styled-components';
export var MopList = styled.ul.withConfig({
  componentId: "sc-i1397c-0"
})(["list-style-type:none;padding:0;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/MopListView/styled.js
// module id = 4571
// module chunks = 11